import React, { ElementType, ForwardedRef, forwardRef } from 'react';

import { default as UnstyledGrid2 } from '@mui/material/Grid2';

import type { Grid2Props as UnstyledGrid2Props } from '@mui/material/Grid2';

export interface Grid2Props extends UnstyledGrid2Props {
    ellipsis?: boolean;
    component?: ElementType;
}

const GridWithEllipsis = ({ sx, ...restProps }: Grid2Props) => (
    <UnstyledGrid2
        sx={[
            ...(Array.isArray(sx) ? sx : [sx]),
            {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '100%'
            }
        ]}
        {...restProps}
    />
);

const Grid = forwardRef(function GridRef({ ellipsis, ...gridProps }: Grid2Props, ref: ForwardedRef<HTMLDivElement>) {
    return ellipsis ? <GridWithEllipsis {...gridProps} /> : <UnstyledGrid2 {...gridProps} ref={ref} />;
});

export default Grid;
